// @flow
import React from 'react';
import classNames from 'classnames';
import randomId from '../../../../javascripts/utils/random-id';
import Label from '../../label/react/Label';
import Icon from '../../../_particles/icon/react/Icon';
import { t } from '../../../../javascripts/utils/withTranslation';

export type Props = {
  options: Array<{ value: string, text: string }>,
  color?: string,
  className?: string,
  label?: string,
  labelAdornment?: React.Node,
  'aria-label'?: string,
  onChange?: (event: SyntheticEvent<HTMLSelectElement>) => void,
  onClear?: () => void,
  value?: string,
  clearLabel?: string,
  hint?: string,
  disabled?: boolean,
  id?: string,
};

const Select = (props: Props): React$MixedElement => {
  const {
    options,
    color,
    label,
    labelAdornment,
    onClear,
    hint,
    clearLabel,
    id,
    ...rest
  } = props;
  const selectId = id || React.useId();
  const selectRef = React.useRef<?HTMLSelectElement>(null);

  const handleClear = () => {
    if (selectRef.current) {
      selectRef.current.value = '';
      selectRef.current.dispatchEvent(new Event('change', { bubbles: true }));
      selectRef.current?.focus();
    }
  };

  return (
    <div className={classNames('select__wrap', rest.className)}>
      {label && (
        <div className="select__label-wrap">
          <Label htmlFor={selectId}>
            {label} {labelAdornment}
          </Label>
        </div>
      )}

      <div className="select__inner-wrap">
        <select
          {...rest}
          id={selectId}
          className={classNames(
            'select',
            color && `select--${color}`,
            onClear && 'select--clearable',
          )}
          ref={selectRef}
        >
          <option className="select__hint" disabled={true} value="">
            {hint || t('Auswählen')}
          </option>

          {options &&
            options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.text}
              </option>
            ))}
        </select>

        {onClear && Boolean(rest.value) && (
          <button
            className="button select__clear"
            type="button"
            aria-label={clearLabel || t('Eingabe löschen')}
            onClick={handleClear}
          >
            <Icon icon="bw-cross-large-line" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Select;
